var map = {
	"./loader_16px_black": [
		54162,
		4162
	],
	"./loader_16px_black.json": [
		54162,
		4162
	],
	"./loader_16px_primary": [
		40494,
		494
	],
	"./loader_16px_primary.json": [
		40494,
		494
	],
	"./loader_16px_white": [
		90187,
		187
	],
	"./loader_16px_white.json": [
		90187,
		187
	],
	"./loader_20px_black": [
		82366,
		2366
	],
	"./loader_20px_black.json": [
		82366,
		2366
	],
	"./loader_20px_primary": [
		31924,
		1924
	],
	"./loader_20px_primary.json": [
		31924,
		1924
	],
	"./loader_20px_white": [
		12846,
		2846
	],
	"./loader_20px_white.json": [
		12846,
		2846
	],
	"./loader_32px_black": [
		37999,
		7999
	],
	"./loader_32px_black.json": [
		37999,
		7999
	],
	"./loader_32px_primary": [
		31403,
		1403
	],
	"./loader_32px_primary.json": [
		31403,
		1403
	],
	"./loader_32px_white": [
		10708,
		708
	],
	"./loader_32px_white.json": [
		10708,
		708
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10339;
module.exports = webpackAsyncContext;